import { render, staticRenderFns } from "./ClientProductsNew.vue?vue&type=template&id=6b2ed48e&scoped=true"
import script from "./ClientProductsNew.vue?vue&type=script&lang=js"
export * from "./ClientProductsNew.vue?vue&type=script&lang=js"
import style0 from "./ClientProductsNew.vue?vue&type=style&index=0&id=6b2ed48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ed48e",
  null
  
)

export default component.exports